import { gql } from '@apollo/client';

export const ALL_FUNDING_CLASSIFICATIONS = gql`
  query AllFundingClassifications {
    fundingClassifications: getFundingClassifications {
      id
      name
    }
  }
`;
